<script>
    import {fly} from 'svelte/transition'
    import Player from "../components/Player.svelte";
    import {onMount} from "svelte";
    let streamId = null;

    onMount(() => {
        const load = () => {
            fetch('https://stopgame.ru/ajax/streams/get')
                .then(response => response.json())
                .then(data => {
                    if (data.response.length === 0) {
                        streamId = null
                        return
                    }
                    if (data.response.includes(streamId)) {
                        return
                    }
                    streamId = data.response[0]
                })
                .finally(() => {
                    console.log(streamId)
                    setTimeout(load, 1000)
                })
        }
        load()
    })

</script>

<main>
    {#if streamId !== null}
        {#key streamId}
            <Player stream={streamId} full={true} />
        {/key}
    {/if}
    {#if !streamId}
        <img class="poster" transition:fly={{ duration: 1000, x: 0, y: -1080, opacity: 1 }} src="/poster.jpg" alt="" />
    {/if}
</main>

<style>
    .poster {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
